import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import App from '@/App'
import { lightTheme } from '../src/shared/styles/theme'
import './index.css'
import { HelmetProvider } from 'react-helmet-async'
import { initializeGoogleAnalytics } from '@/app/analytics'

const enableMocking = async () => {
  if (!import.meta.env.DEV) return
  if (import.meta.env.VITE_ENABLE_MSW !== 'true') return

  const { worker } = await import('./mocks/browser')

  return worker.start({
    onUnhandledRequest: 'bypass', // ハンドラーがないリクエストは通常通り処理
  })
}

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

initializeGoogleAnalytics()
enableMocking().then(() => {
  createRoot(root).render(
    <StrictMode>
      <ThemeProvider theme={lightTheme}>
        <HelmetProvider>
          <RouterProvider router={App} />
        </HelmetProvider>
      </ThemeProvider>
    </StrictMode>
  )
})
